module.exports = __webpack_public_path__ + "img/boundary-message-event.68472c0d.svg";